import axios from 'axios';

import { BASE_URL } from './config';
const ENDPOINT = '/api/employees/schedule/upload';

export function postProfessorsSchedule(file: File) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  const formData = new FormData();
  formData.append('schedule', file);

  return apiClient.post(ENDPOINT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
